'use strict';

exports.__esModule = true;
exports['default'] = configureStore;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _redux = require('redux');

var _reduxLogger = require('redux-logger');

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _reduxPromise = require('redux-promise');

var _reduxPromise2 = _interopRequireDefault(_reduxPromise);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var loggerMiddleware = _reduxLogger2['default']({
  level: 'info',
  collapsed: true
});

var createStoreWithMiddleware = _redux.applyMiddleware(_reduxThunk2['default'], _reduxPromise2['default'], loggerMiddleware)(_redux.createStore);

function configureStore(initialState) {
  var store = createStoreWithMiddleware(_reducers2['default'], initialState);

  if (module.hot) {
    // Enable hot module replacement for reducers
    module.hot.accept('./reducers', function () {
      var nextRootReducer = require('./reducers');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

module.exports = exports['default'];